import { h } from "preact";
import firstEligibleDiscountMessage from "./firstEligibleDiscountMessage";
import parseDiscountMessage from "./parseDiscountMessage";

const injectMessage = ({ message, quantity, percentage }) => {
  return message
    .replace("[quantity]", quantity)
    .replace("[percentage]", percentage);
};

export default function MiniCartBundleProgress({ items }) {
  const discountMessage = firstEligibleDiscountMessage(
    items[0]?.additionalData?.merchandise?.discountMessages,
  );

  if (!discountMessage) return null;

  const parsedDiscountMessage = parseDiscountMessage(discountMessage);

  if (!parsedDiscountMessage) return null;

  const {
    bundleTitle,
    message,
    successMessage,
    minimumQuantityTiers,
    percentageOffTiers,
  } = parsedDiscountMessage;

  const totalQuantity = items.reduce((count, item) => count + item.quantity, 0);

  let currentTier = null;
  let nextTier = 0;

  minimumQuantityTiers.forEach((tier, i) => {
    if (totalQuantity >= tier) {
      currentTier = i;
      nextTier = i + 1 < minimumQuantityTiers.length ? i + 1 : null;
    }
  });

  let successMessageText = null;
  let messageText = null;

  if (currentTier !== null) {
    successMessageText = injectMessage({
      message: successMessage,
      quantity: totalQuantity,
      percentage: percentageOffTiers[currentTier],
    });
  }

  if (nextTier !== null) {
    messageText = injectMessage({
      message,
      quantity: minimumQuantityTiers[nextTier] - totalQuantity,
      percentage: percentageOffTiers[nextTier],
    });
  }

  const messages = [successMessageText, messageText]
    .filter((text) => text)
    .join(", ");

  const progressItemCount =
    minimumQuantityTiers[nextTier !== null ? nextTier : currentTier];

  return (
    <div className="mini-cart-bundle">
      <div className="mini-cart-bundle__title">{bundleTitle}</div>
      <div className="mini-cart-bundle__content">
        <div>{messages}</div>
        <div>
          {window.localeStrings.cart.bundle_quantity_added.replace(
            "[count]",
            totalQuantity,
          )}
        </div>
      </div>
      <div className="mini-cart-bundle__progress">
        {new Array(progressItemCount).fill(null).map((_, i) => (
          <div
            className={`mini-cart-bundle__progress-item ${i < totalQuantity ? "mini-cart-bundle__progress-item--filled" : ""}`}
          ></div>
        ))}
      </div>
    </div>
  );
}
